import { defineRenderNode } from './renderNodeDefs.js';
import type { RenderNodeDefsSubset } from './renderNodeDefs.js';




export const SDF_NODE_DEFS: RenderNodeDefsSubset<
  | 'Rect'
  | 'Circle'
  | 'Union'
  | 'Difference'
  | 'Intersect'
  | 'Xor'
  | 'SmoothUnion'
  | 'SmoothSubtract'
  | 'SmoothIntersect'
> = {
  Rect: defineRenderNode({
    label: 'Rect', cat: 'sdf', subcat: 'shapes',
    inputs: [
      { name: 'width', label: 'Width', type: 'float', range: { min: 0, max: 4096, step: 1, subtype: 'pixels' } },
      { name: 'height', label: 'Height', type: 'float', range: { min: 0, max: 4096, step: 1, subtype: 'pixels' } },
      { name: 'cornerRadius', label: 'Corner radius', type: 'float', range: { min: 0, max: 2048, step: 1, subtype: 'pixels' } },
    ],
    outputs: [{ name: 'shape', label: 'Shape', type: 'shape' }],
    graphs: ['geometry']
  }),
  Circle: defineRenderNode({
    label: 'Circle', cat: 'sdf', subcat: 'shapes',
    inputs: [{ name: 'radius', label: 'Radius', type: 'float', range: { min: 0, max: 2048, step: 1, subtype: 'pixels' } }],
    outputs: [{ name: 'shape', label: 'Shape', type: 'shape' }],
    graphs: ['geometry']
  }),
  Union: defineRenderNode({
    label: 'Union', cat: 'sdf', subcat: 'boolean',
    inputs: [
      { name: 'a', label: 'A', type: 'shape' },
      { name: 'b', label: 'B', type: 'shape' },
    ],
    outputs: [{ name: 'shape', label: 'Shape', type: 'shape' }],
    graphs: ['geometry']
  }),
  Difference: defineRenderNode({
    label: 'Difference', cat: 'sdf', subcat: 'boolean',
    inputs: [
      { name: 'a', label: 'A', type: 'shape' },
      { name: 'b', label: 'B', type: 'shape' },
    ],
    outputs: [{ name: 'shape', label: 'Shape', type: 'shape' }],
    graphs: ['geometry']
  }),
  Intersect: defineRenderNode({
    label: 'Intersect', cat: 'sdf', subcat: 'boolean',
    inputs: [
      { name: 'a', label: 'A', type: 'shape' },
      { name: 'b', label: 'B', type: 'shape' },
    ],
    outputs: [{ name: 'shape', label: 'Shape', type: 'shape' }],
    graphs: ['geometry']
  }),
  Xor: defineRenderNode({
    label: 'Xor', cat: 'sdf', subcat: 'boolean',
    inputs: [
      { name: 'a', label: 'A', type: 'shape' },
      { name: 'b', label: 'B', type: 'shape' },
    ],
    outputs: [{ name: 'shape', label: 'Shape', type: 'shape' }],
    graphs: ['geometry']
  }),
  SmoothUnion: defineRenderNode({
    label: 'Smooth Union', cat: 'sdf', subcat: 'smooth-boolean',
    inputs: [
      { name: 'distance1', label: 'Distance 1', type: 'float' },
      { name: 'boundsA', label: 'Bounds A', type: 'bounds' },
      { name: 'distance2', label: 'Distance 2', type: 'float' },
      { name: 'boundsB', label: 'Bounds B', type: 'bounds' },
      { name: 'smoothness', label: 'Smoothness', type: 'float' },
      { name: 'density', label: 'Density', type: 'float', range: { min: 0, max: 100, step: 0.01, subtype: 'factor' } },
    ],
    outputs: [
      { name: 'distance', label: 'Distance', type: 'float' },
      { name: 'contourBounds', label: 'Contour bounds', type: 'bounds' },
    ],
    graphs: ['material']
  }),
  SmoothSubtract: defineRenderNode({
    label: 'Smooth Subtract', cat: 'sdf', subcat: 'smooth-boolean',
    inputs: [
      { name: 'distance1', label: 'Distance 1', type: 'float' },
      { name: 'boundsA', label: 'Bounds A', type: 'bounds' },
      { name: 'distance2', label: 'Distance 2', type: 'float' },
      { name: 'boundsB', label: 'Bounds B', type: 'bounds' },
      { name: 'smoothness', label: 'Smoothness', type: 'float' },
      { name: 'density', label: 'Density', type: 'float', range: { min: 0, max: 100, step: 0.01, subtype: 'factor' } },
    ],
    outputs: [
      { name: 'distance', label: 'Distance', type: 'float' },
      { name: 'contourBounds', label: 'Contour bounds', type: 'bounds' },
    ],
    graphs: ['material']
  }),
  SmoothIntersect: defineRenderNode({
    label: 'Smooth Intersect', cat: 'sdf', subcat: 'smooth-boolean',
    inputs: [
      { name: 'distance1', label: 'Distance 1', type: 'float' },
      { name: 'boundsA', label: 'Bounds A', type: 'bounds' },
      { name: 'distance2', label: 'Distance 2', type: 'float' },
      { name: 'boundsB', label: 'Bounds B', type: 'bounds' },
      { name: 'smoothness', label: 'Smoothness', type: 'float' },
      { name: 'density', label: 'Density', type: 'float', range: { min: 0, max: 100, step: 0.01, subtype: 'factor' } },
    ],
    outputs: [
      { name: 'distance', label: 'Distance', type: 'float' },
      { name: 'contourBounds', label: 'Contour bounds', type: 'bounds' },
    ],
    graphs: ['material']
  }),
};
